import React, { Fragment, useRef } from "react";
import useMeasure from "react-use-measure";
import { mergeRefs } from "react-merge-refs";
import { useAppContext } from "../helpers/account-context";

import { toPermalink } from "../helpers/helper";
import { HoursDetail } from "./Components/HoursInfo";
import { CtaDetail } from "./Components/CtaInfo";
import { FieldsDetail } from "./Components/FieldsInfo";
import { ActionsDetail } from "./Components/ActionsInfo";
import { SocialsDetail } from "./Components/SocialsInfo";
import { HeroDetail } from "./Components/HeroInfo";
import { CustomFieldsDetail } from "./Components/CustomFieldsInfo";
import { TagsDetail } from "./Components/TagsInfo";
import { HorizonalLine } from "./Components/Mixin";
import { DirectionDetail } from "./Components/DirectionInfo";
import { DistanceDetail } from "./Components/DistanceInfo";
import { ViewDetailsDetail } from "./Components/ViewDetailsInfo";

const InfoRow = (props) => {
  const { fieldName } = props;

  if (fieldName === "name" || fieldName === "location_type_name")
    return <FieldsDetail {...props} fieldName={fieldName} hiddenLabel={true} />;
  if (fieldName === "hours") return <HoursDetail {...props} />;
  if (fieldName === "actions") return <ActionsDetail {...props} />;
  if (fieldName === "socials") return <SocialsDetail {...props} />;
  if (fieldName === "cta_buttons") return <CtaDetail {...props} />;
  if (fieldName === "custom_fields") return <CustomFieldsDetail {...props} />;
  if (fieldName === "tags") return <TagsDetail {...props} />;
  if (fieldName === "directions") return <DirectionDetail {...props} />;
  if (fieldName === "distance") return (<DistanceDetail {...props} />);
  if (fieldName === "view_details")
    return (
      <ViewDetailsDetail {...props}/>
    );

  if (fieldName && !!fieldName.match(/hr\d{1}/i))
    return <HorizonalLine {...props} />;

  return <FieldsDetail {...props} fieldName={fieldName} hiddenLabel={true} />;
};

const LocationDialog = (props) => {
  const { account } = useAppContext();
  const [containerRef, containerBounds] = useMeasure();
  const [innerRef, innerBounds] = useMeasure();
  const contentRef = useRef();

  const { item, onClose, isOpen } = props;
  const { dialog = {} } = account;
  const fields = dialog && dialog.fields ? dialog.fields : [];
  const handleOnClick = (e) => {
    e.preventDefault();
    onClose(e);
  };

  if (!item) return null;

  const isScrollable =
    containerBounds &&
    innerBounds &&
    containerBounds.height < contentRef.current?.scrollHeight;
    
  return (
    <Fragment>
      <div
        className={`cbmap-dialog cbmap-details-dialog ${
          isOpen ? "cbmap-visible" : "cbmap-invisible"
        }`}
      >
        <button className="cbmap-btn-close" onClick={handleOnClick}>
          &times;
        </button>

        <div
          className={`cbmap-body cbmap-scrollable ${
            isScrollable ? "cbmap-overheight" : ""
          }`}
          ref={containerRef}
        >
          <div
            ref={mergeRefs([contentRef, innerRef])}
            className={`cbmap-loc-details cbmap-hero-pos_${dialog.hero_position}`}
          >
            {!!dialog.hero_position && dialog.hero_position !== "hidden" && (
              <HeroDetail fieldName="hero" {...props} />
            )}
            <div className="cbmap-details-props">
              {fields.map((fieldName) => (
                <InfoRow
                  key={`${item.properties.id}-${toPermalink(fieldName)}`}
                  {...props}
                  fieldName={fieldName}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default LocationDialog;
